<template>
  <v-container>
    <v-row>
      <v-col>
        <DragAndDropFile
            ref="dragAndDrop"
            custom-height="80vh"
            not-required
            :view-only="viewOnly"
            @fileChange="setFile($event)"
        />
      </v-col>
      <v-col>
        <v-form ref="form">
          <v-row justify="space-between">
            <v-col cols="12" md="4">
              <CustomerTypeAhead
                  ref="customerTypeahead"
                  :value="orderDocumentation.supplierId"
                  @input="($event) => orderDocumentation.supplierId = $event"
                  @inputName="($event) => orderDocumentation.supplier = $event"
                  :label="$t('book/issue:common.supplier')"
                  required
                  :suppliersOnly="true"
              />
            </v-col>
            <v-col cols="12" md="4">
              <DateField
                  ref="validFrom"
                  @update="(v) => orderDocumentation.startDate = v"
                  :isClearable="true"
                  :key="validFromKey"
                  :label="$t('book/issue:common.implementation-date')"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                  clearable
                  outlined
                  :label="$t('common:note')"
                  :readonly="viewOnly"
                  v-model="orderDocumentation.note" />
            </v-col>
          </v-row>
          <v-row v-if="!hideButton">
            <v-col>
              <BaseButton
                  color="primary"
                  :btnText="buttonLabel"
                  @clickedButton="save()"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

import DragAndDropFile from '@/modules/core/components/DragAndDropFile';
import DateField from '@/modules/core/components/DateField.vue';
import BaseButton from '@/modules/core/components/Base/BaseButton.vue';
import TaskDocumentationService from '@/modules/book/services/task-documentation/task-documentation-service';
import Utils from '@/modules/core/services/utils';
import TaskDocumentation from '@/modules/book/data/task-documentation';
import DocumentationService from '@/modules/core/services/documentation-service';
import {DocumentType} from '@/modules/book/data/document-type';
import CustomerTypeAhead from '@/modules/core/components/CustomerTypeAhead.vue';

export default {
  name: 'OrderDocumentationForm',
  components: {CustomerTypeAhead, BaseButton, DateField, DragAndDropFile},
  props: {
    hideButton: Boolean,
    viewOnly: Boolean
  },
  data() {
    return {
      isNewItem: false,
      validFromKey: 1,
      orderDocumentation: new TaskDocumentation(),
      file: null
    }
  },
  computed: {
    buttonLabel() {
      if (!this.isNewItem) return this.$t('save-changes');

      return this.$t('buttons:add-specific', { specific: this.$t('book/issue:taskDocumentation') });
    }
  },
  methods: {
    setInputData(inputData) {
      this.orderDocumentation.task = inputData.taskId;
      this.orderDocumentation.customer = inputData.customerId;
      this.$refs.dragAndDrop.uploadAsUrl(inputData.file);
      this.file = inputData.file;
    },
    setCreateData(taskInfo) {
      this.inputData = taskInfo;
      this.orderDocumentation.task = taskInfo.taskId;
      this.orderDocumentation.customer = taskInfo.customerId;
      this.isNewItem = true;
    },
    setViewData(orderDocumentation) {
      if (!orderDocumentation) return;
      this.orderDocumentation = orderDocumentation;
      this.isNewItem = false;

      if (this.orderDocumentation.startDate) {
        this.orderDocumentation.startDate =
            this.$refs.validFrom.parseDTO(this.orderDocumentation.startDate);
      }

      if (this.orderDocumentation.supplierId !== null) {
        this.$refs.customerTypeahead.initialise(this.orderDocumentation.supplierId);
      }

      this.loadStaticFileUrl();
    },
    setFile(item) {
      this.file = item;

      if (item) {
        let docuToParse = {
          fileType: item.type,
          src: URL.createObjectURL(item)
        }
        this.$refs.dragAndDrop.setPreviewSrc(docuToParse)
      } else {
        this.$refs.dragAndDrop.setPreviewSrc(null)
      }

      this.$refs.dragAndDrop.file = item;
      this.$refs.dragAndDrop.isUploading = false;
    },
    save() {
      this.$refs.dragAndDrop.isMandatoryFilledOut();
      if (!this.$refs.form.validate()
          || !this.$refs.dragAndDrop.isMandatoryFilledOut()) {
        document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
        return;
      }

      let label = this.orderDocumentation.id ? 'snackbar:update-success' : 'snackbar:add-success';
      let failLabel = this.orderDocumentation.id ? 'snackbar:update-failure' : 'snackbar:add-failure';
      this.orderDocumentation.isOrderDocumentation = true;
      TaskDocumentationService.saveOrUpdate(
          this.orderDocumentation,
          this.file,
          () => {
            Utils.showSuccessSnackbar(this.$t(label, {name: this.$t('book/issue:common.order')}));
            this.$emit('closeDialog');
          },
          () => {
            Utils.showFailureSnackbar(this.$t(failLabel, {name: this.$t('book/issue:common.order')}))
            this.$emit('closeDialog');
          }
      )
    },
    removeDocument() {
      TaskDocumentationService.delete(this.taskDocumentation.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('book/issue:common.order')}));
            this.$emit('closeDialog');
          },
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('book/issue:common.order')}));
            this.$emit('closeDialog');
          }
      );
    },
    loadStaticFileUrl() {
      DocumentationService.getDocByTypeAndId(
          this.orderDocumentation.id,
          this.orderDocumentation.fileType,
          DocumentType.OFFER_TASK,
          this.orderDocumentation.task,
          (fileUrl) => {
            this.orderDocumentation.src = fileUrl;
            this.$refs.dragAndDrop.setPreviewSrc(this.orderDocumentation);
          },
          () => {
            this.$refs.dragAndDrop.clear();
          }
      )
    },
    clearForm() {
      this.orderDocumentation = new TaskDocumentation();
      this.$refs.dragAndDrop.clear();
      this.$refs.form.reset();
      this.validFromKey++;
      this.isNewItem = false;
    }
  }
}
</script>